import { useLayoutType, LayoutTypes } from "@/util-react/layout";

export const useIsMobile = () => {
  const { layoutType } = useLayoutType();

  return layoutType === LayoutTypes.TYPE_MOBILE;
};
